import { ActionTypes } from '../../constants';
import { polyglot } from '../../assets/locales';

let defaultState = {
  data: null,
  currentStep: 1,
  continueClicked: false,
};

function ValidationReducer (state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_VALIDATION_DATA:
      return { ...state, data: action.payload.validationData };
    default:
      return state;
  }
}

export default ValidationReducer;